/**
 * Token package configurations
 * Defines available token purchase options with pricing details
 */
export interface TokenPackage {
  tokens: number;
  price: number;
  pricePerToken: number;
  popular: boolean;
  bestValue: boolean;
}

export const TOKEN_PACKAGES: TokenPackage[] = [
  { tokens: 100, price: 9.8, pricePerToken: 0.09, popular: false, bestValue: false },
  { tokens: 300, price: 24.8, pricePerToken: 0.08, popular: false, bestValue: false },
  { tokens: 650, price: 48.80, pricePerToken: 0.07, popular: true, bestValue: false },
  { tokens: 1200, price: 78.80, pricePerToken: 0.06, popular: false, bestValue: false },
  { tokens: 2500, price: 98.80, pricePerToken: 0.04, popular: false, bestValue: false },
  { tokens: 10000, price: 248.80, pricePerToken: 0.02, popular: false, bestValue: true },
]; 